import { FC, ReactNode } from "react";
import { Box, TableContainer } from "@chakra-ui/react";

export interface DataTableProps {
  /** Conteúdo da tabela (<Table variant="compact">…</Table>). */
  children: ReactNode;
}

// Card branco no padrão Rede Frota - Cardan: envolve uma tabela crua do Chakra
// (variant="compact") num container branco com borda sutil e cantos
// arredondados. Use junto do FiltroBar acima. Não converte a tabela para a API
// de colunas do AppTable — só provê a moldura visual, preservando o JSX
// existente (badges, isNumeric, cores condicionais).
export const DataTable: FC<DataTableProps> = ({ children }) => (
  <Box
    bg="neutrals.surface.surface-0"
    border="1px solid"
    borderColor="neutrals.stroke.soft-200"
    borderRadius="8px"
    overflow="hidden"
  >
    <TableContainer overflowX="auto">{children}</TableContainer>
  </Box>
);
